import classNames from 'classnames';

export const getWrapperClassNames = (isCssVariationMobile, showOneEntryPoint, isOneEntryPoint, isOneEntryPointAppBanner) => classNames({
    'odf-space-inner-left-m odf-space-inner-right-m': !isCssVariationMobile,
    'prisma-responsive-space-horizontal': isCssVariationMobile && !showOneEntryPoint,
    'odf-position-relative odf-bg-base': true,
    'odf-space-inner-top-m  odf-space-inner-bottom-m': !showOneEntryPoint,
    'odf-space-inner-top-l  odf-space-inner-bottom-l': showOneEntryPoint,
    'od-one-entry-wrapper': isOneEntryPoint && showOneEntryPoint,
    'od-one-entry-wrapper-iteration2': isOneEntryPointAppBanner && showOneEntryPoint,
    'od-flights-manager-wrapper': !showOneEntryPoint
});

export const getTripTypeWrapperClassNames = (isCssVariationMobile) => classNames({
    'odf-space-outer-bottom-m': !isCssVariationMobile,
    'odf-space-outer-top-s odf-space-outer-bottom-l': isCssVariationMobile,
});

export const getButtonWrapperClassNames = (isCssVariationMobile, airlineIata, airlineName) => classNames({
    'odf-space-outer-top-m': !isCssVariationMobile || (airlineIata && airlineName),
    'odf-space-outer-top-2xl': isCssVariationMobile && !(airlineIata && airlineName),
});

export const getSecondaryButtonClassNames = (isCssVariationMobile) => classNames({
    'odf-space-outer-top-s': !isCssVariationMobile,
    'odf-space-outer-top-m': isCssVariationMobile,
});

export const getFlightsManagerClassNames = (showOneEntryPoint) => classNames({
    'odf-text-left': !showOneEntryPoint,
    'od-one-entry-styles': showOneEntryPoint,
    'od-mobile-manager-default': !showOneEntryPoint,
});
